define([
	"dojo/_base/declare",
	"csi/form/Widget"
], function(declare,Widget) {

	return declare(Widget, {
		isFieldEditable: function(/*Field*/field) {
			if(field.m_id == "Market" || field.m_id == "SKUBasedOrder") {
				//S12884 make the SalesMarket and SKUBasedOrder editable only when creating new Sales Order
				return this.getFormData().getSource().m_action.m_id == "NewSalesOrder";
			}
			return this.inherited(arguments);
		}
	});
});